<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout === 'empty') {
  <spri-empty-layout />
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with horizontal navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Centered -->
@if (layout === 'centered') {
  <spri-centered-layout />
}

<!-- Enterprise -->
@if (layout === 'enterprise') {
  <spri-enterprise-layout />
}

<!-- Material -->
@if (layout === 'material') {
  <spri-material-layout />
}

<!-- Modern -->
@if (layout === 'modern') {
  <spri-modern-layout />
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with vertical navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Classic -->
@if (layout === 'classic') {
  <spri-classic-layout />
}

<!-- Classy -->
@if (layout === 'classy') {
  <spri-classy-layout />
}

<!-- Compact -->
@if (layout === 'compact') {
  <spri-compact-layout />
}

<!-- Futuristic -->
@if (layout === 'futuristic') {
  <spri-futuristic-layout />
}

<!-- Thin -->
@if (layout === 'thin') {
  <spri-thin-layout />
}

<!-- SPRI -->
@if (layout === 'dense') {
  <spri-spri-layout />
}

<!-- Patient form layout -->
@if (layout === 'patient-form-layout') {
  <spri-patient-form-layout />
}
